import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { UserProfile } from '../user/UserProfile'

// The server copies the assigned user's profile onto the conversation when the assignee changes
// and never refreshes it on a later rename — the conversation keeps the name it was assigned under.
@ObjectType()
@InputType('ChatAssigneeInput')
export class ChatAssignee {
  @Field(() => ID)
  @Prop({ type: String, required: true })
  _id: string

  @Field(() => UserProfile, { nullable: true })
  @Prop({ type: UserProfile })
  profile?: UserProfile
}
